export default __webpack_public_path__ + "static/media/roof_trinity.26121d74.jpg";